"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var level1DataProp = _interopRequireWildcard(require("../../propTypes/level1Data"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _numberFormatter = require("../../helpers/numberFormatter");
var _level1Helper = require("../../helpers/level1Helper");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
require("./MarketDataCardComponent.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var marketDataItemClasses = (0, _cssClassesHelper.getBEMClasses)('market-data-card');
var MarketDataCardComponent = function MarketDataCardComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var product1 = props.product1,
    product2 = props.product2,
    instrument = props.instrument,
    _props$level1Data = props.level1Data,
    LastTradedPx = _props$level1Data.LastTradedPx,
    Rolling24HrVolume = _props$level1Data.Rolling24HrVolume,
    Rolling24HrPxChange = _props$level1Data.Rolling24HrPxChange,
    Rolling24HrPxChangePercent = _props$level1Data.Rolling24HrPxChangePercent,
    SessionHigh = _props$level1Data.SessionHigh,
    SessionLow = _props$level1Data.SessionLow,
    BestBid = _props$level1Data.BestBid,
    BestOffer = _props$level1Data.BestOffer,
    coin = props.coin;
  var rolling24HrPxChangeValue = (0, _level1Helper.calculateRolling24HrPxChangeValue)(LastTradedPx, Rolling24HrPxChange);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('row')
  }, coin ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    iconFileName: product1.iconFileName,
    size: 40
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('coins-header-text')
  }, "".concat(product1.ProductFullName, " ").concat(product1.ProductSymbol))) : /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(product1.ProductFullName, " / ").concat(product2.ProductFullName),
    text: "".concat(product1.Product, "/").concat(product2.Product),
    customClass: marketDataItemClasses(),
    classModifiers: 'header'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Last Price'),
    text: (0, _numberFormatter.formatNumberToLocale)(LastTradedPx, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    customClass: marketDataItemClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('24-Hour Change'),
    text: (0, _numberFormatter.formatNumberToLocale)(rolling24HrPxChangeValue, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    customClass: marketDataItemClasses(),
    classModifiers: rolling24HrPxChangeValue.gte(0) ? '24h-positive' : '24h-negative'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('24-Hour Pct Change'),
    text: (0, _numberFormatter.formatPercentageValue)(Rolling24HrPxChangePercent),
    customClass: marketDataItemClasses(),
    classModifiers: Rolling24HrPxChangePercent >= 0 ? '24h-positive' : '24h-negative'
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('24-Hour Vol.'),
    text: (0, _numberFormatter.formatNumberToLocale)(Rolling24HrVolume, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.QuantityIncrement)),
    customClass: marketDataItemClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('24-Hour High'),
    text: (0, _numberFormatter.formatNumberToLocale)(SessionHigh, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    customClass: marketDataItemClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('24-Hour Low'),
    text: (0, _numberFormatter.formatNumberToLocale)(SessionLow, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    customClass: marketDataItemClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Bid'),
    text: (0, _numberFormatter.formatNumberToLocale)(BestBid, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    customClass: marketDataItemClasses(),
    classModifiers: "bid"
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Ask'),
    text: (0, _numberFormatter.formatNumberToLocale)(BestOffer, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    customClass: marketDataItemClasses(),
    classModifiers: "ask"
  })), coin && /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('activity')
  }, "View Activity \u2192"), /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('icons')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('icon-container')
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "buy",
    customClass: marketDataItemClasses('icon')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: marketDataItemClasses('icon-container')
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "sell",
    customClass: marketDataItemClasses('icon')
  })))));
};
MarketDataCardComponent.propTypes = {
  level1Data: level1DataProp.type.isRequired,
  product1: _propTypes["default"].object.isRequired,
  product2: _propTypes["default"].object.isRequired,
  coin: _propTypes["default"].bool
};
var _default = exports["default"] = MarketDataCardComponent;